<template>
  <div class="shl-result-empty">
    {{ $tr('interview.landing.modules.shl.reports-empty') }}
  </div>
</template>

<script>
  export default {
    name: "shl-result-empty"
  }
</script>

<style scoped lang="scss">
.shl-result-empty {
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  margin: 15px 0;
}
</style>